import { render, staticRenderFns } from "./mdc-chip-set.vue?vue&type=template&id=629f6717&"
import script from "./mdc-chip-set.vue?vue&type=script&lang=ts&"
export * from "./mdc-chip-set.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports